// src/services/PasswordService.js - FIXED EXPORT
import bcrypt from 'bcryptjs';

/**
 * Hash a plain text password
 * @param {string} plainPassword - The password to hash
 * @returns {Promise<string>} - The hashed password
 */
export const hashPassword = async (plainPassword) => {
  try {
    const saltRounds = 10; // Industry standard
    const hashedPassword = await bcrypt.hash(plainPassword, saltRounds);
     
    return hashedPassword;
  } catch (error) {
    console.error('❌ Error hashing password:', error);
    throw new Error('Failed to hash password');
  }
};

/**
 * Compare a plain text password with a hashed password
 * @param {string} plainPassword - The plain text password
 * @param {string} hashedPassword - The hashed password to compare against
 * @returns {Promise<boolean>} - True if passwords match, false otherwise
 */
export const comparePassword = async (plainPassword, hashedPassword) => {
  try {
    const isMatch = await bcrypt.compare(plainPassword, hashedPassword);
    return isMatch;
  } catch (error) {
    console.error('❌ Error comparing passwords:', error);
    return false;
  }
};

/**
 * Check if a password is already hashed (bcrypt format)
 * @param {string} password - The password to check
 * @returns {boolean} - True if already hashed, false otherwise
 */
export const isHashed = (password) => {
  // Bcrypt hashes start with $2a$, $2b$, or $2y$ and are 60 characters long
  const bcryptRegex = /^\$2[aby]\$\d{2}\$.{53}$/;
  return bcryptRegex.test(password);
};

// Default export object for backward compatibility
const PasswordService = {
  hashPassword,
  comparePassword,
  isHashed
};

export default PasswordService;